import { TransferKeys } from "@/modules/transaction/common/enum";
import { useCheckTemplateName } from "@/modules/transaction/hooks";
import { useAppSelector } from "@/shared/hooks";
import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { Switcher } from "@ab.uitools/ui-library/components/Switcher";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { TSetValue } from "@ab.uitools/ui-library/types/globalTypes";
import { type Dispatch, type SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  setValue: TSetValue;
  isSaveAsTemplate: boolean;
  setIsNameUnique: Dispatch<SetStateAction<boolean>>;
}

export const SaveAsTemplate = ({ setValue, isSaveAsTemplate, setIsNameUnique }: Props) => {
  const { t } = useTranslation();
  const featureToggles = useAppSelector(state => state.featureToggle.toggles);

  const { handleCheckTemplateName } = useCheckTemplateName({ setIsNameUnique });

  return featureToggles?.isTemplatesAvailable && (
    <>
      <div className="flexbox justify-content--between mt-32">
        <div className="flex-direction--column">
          <Text type="primary" weight="bolder">
            {t("transfer.saveAsTemplate")}
          </Text>
        </div>
        <FormField
          name="isSaveAsTemplate"
          className="mb-8"
          errorMessageIcon="infoFilled"
          As={(props) => (
            <Switcher
              {...props}
              onClick={(value) => {
                if (!value) {
                  setValue(TransferKeys.TemplateName, "", { shouldValidate: true });
                }
              }}
            />
          )}
        />
      </div>
      {isSaveAsTemplate && (
        <FormField
          name="templateName"
          className="mb-8 mt-20"
          errorMessageIcon="infoFilled"
          As={(props) => (
            <Input
              {...props}
              required
              handleChange={(_, v) => handleCheckTemplateName(v)}
              label={t("transfer.templateName")}
              placeholder={t("transfer.enterTemplateName")}
            />
          )}
        />
      )}
    </>
  );
};
